import FormikFormLine from "../../../../formik-form-components/FormikFormLine";
import React, { forwardRef, Ref } from "react";
import useInventoryBin from "../../../../../utils/hooks/inventory/inventoryBin";
import { BindString } from "../../../../../utils/hooks/inputs";
import FormLine from "../../../../common/FormLine";

function BinBarcodeField(
  {
    binBarcode,
    autoFocus,
    bind,
    isRequired,
  }: {
    binBarcode: string;
    autoFocus?: boolean;
    bind?: BindString;
    isRequired?: boolean;
  },
  ref: Ref<HTMLInputElement> | null,
) {
  const { inventoryBin } = useInventoryBin(binBarcode);

  const FormComponent = bind === undefined ? FormikFormLine : FormLine;

  return (
    <FormComponent
      name="flashpcbBinBarcode"
      label={
        inventoryBin
          ? `FlashPCB Bin Barcode (${inventoryBin.bin_name} - ${inventoryBin.bin_location})`
          : "FlashPCB Bin Barcode"
      }
      isRequired={isRequired || false}
      autoFocus={autoFocus}
      bind={bind}
      ref={ref}
    />
  );
}

export default forwardRef(BinBarcodeField);
